module.exports = __webpack_public_path__ + "img/keyb.2d787af4.png";